import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-cream pt-20 pb-10" data-id="element-12">
      <div className="container mx-auto px-4 md:px-8" data-id="element-13">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-14">
          <div className="lg:col-span-2" data-id="element-15">
            <Link to="/" className="flex flex-col inline-block mb-6" data-id="element-16">
              <span className="font-serif text-3xl font-bold leading-none tracking-tight text-cream" data-id="element-17">
                RADIO AFRICA
              </span>
              <span className="text-sm uppercase tracking-[0.2em] text-saffron font-semibold mt-1" data-id="element-18">
                & Kitchen
              </span>
            </Link>
            <div className="flex gap-4 mt-6" data-id="element-19">
              <a href="https://www.instagram.com/radioafricakitchen?igsh=NTc4MTIwNjQ2YQ==" target="_blank" rel="noopener noreferrer" aria-label="Radio Africa & Kitchen on Instagram" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-saffron hover:text-charcoal transition-colors" data-id="element-20">
                <Instagram size={20} data-id="element-21" />
              </a>
              <a href="https://www.facebook.com/radioafricakitchen" target="_blank" rel="noopener noreferrer" aria-label="Radio Africa & Kitchen on Facebook" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-saffron hover:text-charcoal transition-colors" data-id="element-22">
                <Facebook size={20} data-id="element-23" />
              </a>
            </div>
          </div>

          <div data-id="element-24">
            <h4 className="font-serif text-xl mb-6 text-saffron" data-id="element-25">Contact</h4>
            <ul className="space-y-4" data-id="element-26">
              <li data-id="element-27">
                <a href="mailto:radioafricak@yahoo.com" className="flex items-center gap-3 text-cream/80 hover:text-saffron transition-colors" data-id="element-28">
                  <Mail size={18} className="text-terracotta" data-id="element-29" />
                  radioafricak@yahoo.com
                </a>
              </li>
              <li data-id="element-30">
                <a href="tel:+14154202486" className="flex items-center gap-3 text-cream/80 hover:text-saffron transition-colors" data-id="element-31">
                  <Phone size={18} className="text-terracotta" data-id="element-32" />
                  +1 415 420 2486
                </a>
              </li>
              <li className="flex items-start gap-3 text-cream/80" data-id="element-33">
                <MapPin size={18} className="text-terracotta shrink-0 mt-1" data-id="element-34" />
                <span data-id="element-35">
                  San Francisco Bay Area
                  <br data-id="element-36" />
                  Catering Only
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-37">
            <h4 className="font-serif text-xl mb-6 text-saffron" data-id="element-38">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-39">
              <li data-id="element-40">
                <Link to="/" className="text-cream/80 hover:text-saffron transition-colors" data-id="element-41">
                  Home
                </Link>
              </li>
              <li data-id="element-42">
                <Link to="/menu" className="text-cream/80 hover:text-saffron transition-colors" data-id="element-43">
                  Catering Menu
                </Link>
              </li>
              <li data-id="element-44">
                <button onClick={() => document.getElementById('inquiry')?.scrollIntoView({
                behavior: 'smooth'
              })} className="text-cream/80 hover:text-saffron transition-colors" data-id="element-45">
                  Inquire Now
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-cream/50" data-id="element-46">
          <p data-id="element-47">
            &copy; {new Date().getFullYear()} Radio Africa & Kitchen. All rights
            reserved.
          </p>
          <p data-id="element-48">Catering Only.</p>
        </div>
      </div>
    </footer>;
}